<template>
	<div>
		<div class="modal fade" id="addDelegacjaModal" ref="modalEle" tabindex="-1">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Edycja delegacji</h5>
						<button type="button" class="btn btn-outline-danger btn-sm ms-auto me-5"
							@click="removeDelegacja">Usuń delegację</button>
						<button type="button" class="close" data-bs-dismiss="modal">
							<span>&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row g-3">
							<div class="col-md-4">
								<label class="form-label">Pracownik</label>
								<ejs-combobox v-model="user_id" :dataSource="usersList" :fields="fields"
									:allowFiltering="true" filterType="Contains" placeholder="Wyszukaj pracownika" />
								<div v-if="!user_id && submitted" class="text-danger small">
									Wybierz pracownika.
								</div>
							</div>

							<div class="col-md-4">
								<label class="form-label">Data</label>
								<ejs-daterangepicker placeholder="Wybierz daty" :format="'dd/MM/yyyy'"
									:value="dateRange" :firstDayOfWeek="1" :weekNumber="true"
									@change="onDateRangeChange" />
								<div v-if="submitted && (!startDate || !endDate)" class="text-danger small mt-1">
									Wybierz zakres dat.
								</div>
							</div>

							<div class="col-md-4">
								<label class="form-label">Numer delegacji</label>
								<input v-model="numer" class="form-control form-control-sm" />
							</div>

							<div class="col-md-4">
								<label class="form-label">Miejsce / klient</label>
								<input v-model="miejsce" class="form-control form-control-sm" />
							</div>

							<div class="col-md-4">
								<label class="form-label">Projekt</label>
								<ejs-combobox v-model="project" :dataSource="projectsList" :fields="projectFields"
									:allowFiltering="true" filterType="Contains" placeholder="Wyszukaj projekt" />
							</div>

							<div class="col-md-4">
								<label class="form-label">Cel delegacji</label>
								<ejs-combobox v-model="cel" :dataSource="cele" :fields="celFields"
									:allowFiltering="true" filterType="Contains" placeholder="Wyszukaj cel" />
							</div>

							<div class="col-md-4">
								<label class="form-label">Pojazd</label>
								<ejs-multiselect v-model="pojazd" :dataSource="pojazdy" mode="Box" :fields="pojazdFields" :allowFiltering="true" filterType="Contains" placeholder="Wybierz pojazdy"/>
							</div>

							<div class="col-md-4">
								<label class="form-label">Karta debetowa</label>

								<ejs-combobox v-model="card" :dataSource="karty" :fields="cardFields"
									:allowFiltering="true" filterType="Contains" placeholder="Wyszukaj kartę" />
							</div>

							<div class="col-md-4">
								<label class="form-label">Rozliczony?</label>
								<select v-model="rozliczony" class="form-select form-select-sm">
									<option value="0">Nie</option>
									<option value="1">Tak</option>
								</select>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Zamknij</button>
						<button v-if="!readonly" type="button" class="btn btn-primary" @click="submit">Zapisz</button>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from 'bootstrap';
import { DateRangePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { ComboBoxComponent, MultiSelectComponent } from "@syncfusion/ej2-vue-dropdowns";


export default {
	props: {
		delegacja: Object,
		users: Array,
		projects: Array,
		karty: Array,
		cele: { type: Array, default: () => [] },
		pojazdy: { type: Array, default: () => [] },
		readonly: {
		type: Boolean,
		default: false
	}
	},

	components: { 'ejs-daterangepicker': DateRangePickerComponent, 'ejs-combobox': ComboBoxComponent, 'ejs-multiselect': MultiSelectComponent},

	data() {
		return {
			submitted: false,
			id: null,
			modalObj: null,
			user_id: null,
			dateRange: [],
			startDate: null,
			endDate: null,
			numer: null,
			miejsce: null,
			card: null,
			rozliczony: 0,
			cel: null,
			pojazd: [],
			project: null,
			fields: {
				text: 'full_name',
				value: 'id'
			},
			projectFields: {
				text: 'number',
				value: 'id'
			},
			cardFields: {
				text: 'name',
				value: 'name'
			},
			celFields: {
				text: 'name',
				value: 'name'
			},
			pojazdFields: {
				text: 'nr_rejestracyjny',
				value: 'nr_rejestracyjny'
			}			
		};
	},
	computed: {
		usersList() {
			return this.users.map(u => ({
				id: u.id,
				full_name: `${u.first_name} ${u.last_name}`
			}));
		},
		projectsList() {
			return this.projects.map(p => ({
				id: p.id,
				number: `${p.number}`
			}));
		}
	},
	mounted() {
		this.modalObj = new Modal(this.$refs.modalEle);
	},
	created() {
		const today = new Date();
		this.dateRange = [today, today];
		this.onDateRangeChange({ value: this.dateRange });
	},

	methods: {
		async removeDelegacja() {

			Toast.fire({
				toast: false,
				icon: 'warning',
				title: 'Usunięcie delegacji',
				html: 'Czy na pewno chcesz usunąć tę delegację oraz wszystkie powiązane z nią dane (koszty i pobrane kwoty)?',
				showDenyButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Tak',
				denyButtonText: 'Nie',
				position: 'center',
				timer: false,
			}).then((result) => {

				if (result.isConfirmed) {
					this.$emit('delete-delegacja', this.id);
					this.hide();
				}

			});

		},
		show() {
			const d = this.delegacja;
			this.id = d.id;
			this.user_id = d.user_id;
			this.numer = d.numer;
			this.miejsce = d.miejsce;
			this.cel = d.cel;
			this.pojazd = d.pojazd ? d.pojazd.split(',').map(p => p.trim()) : [];
			this.card = d.card;
			this.rozliczony = d.rozliczony;
			this.project = d.project_id ?? d.project?.id ?? null;
			this.startDate = d.start_date;
			this.endDate = d.end_date;
			this.dateRange = [
				new Date(d.start_date),
				new Date(d.end_date)
			];
			this.modalObj.show();

		},

		onDateRangeChange(args) {
			const [start, end] = args.value || [];

			this.startDate = start ? this.formatDateToYMD(start) : null;
			this.endDate = end ? this.formatDateToYMD(end) : null;
		},
		formatDateToYMD(date) {
			if (!date) return null;

			const y = date.getFullYear();
			const m = String(date.getMonth() + 1).padStart(2, "0");
			const d = String(date.getDate()).padStart(2, "0");

			return `${y}-${m}-${d}`;
		},
		async submit() {
			if (!this.user_id) {

				this.submitted = true;

				this.errorMsg("Wybierz pracownika.");

				return;
			}
			if (!this.startDate || !this.endDate) {

				this.submitted = true;

				this.errorMsg("Wybierz zakres dat.");

				return;
			}

			const payload = {
				id: this.id,
				user_id: this.user_id,
				startDate: this.startDate,
				endDate: this.endDate,
				numer: this.numer,
				miejsce: this.miejsce,
				cel: this.cel,
				pojazd: this.pojazd,
				card: this.card,
				rozliczony: this.rozliczony,
				project: this.project
			};

			this.$emit(
				'update-delegacja',
				payload
			);
			this.hide();
		},

		errorMsg(resp) {
			Toast.fire({
				position: 'top-end',
				toast: true,
				icon: 'warning',
				title: 'Błąd!',
				html: resp,
				showClass: { popup: 'animate__animated animate__fadeInDown' },
				hideClass: { popup: 'animate__animated animate__fadeOutUp' },
				timer: 2500,
				timerProgressBar: true,
				showConfirmButton: false,
				showCloseButton: true
			});
		},

		hide() {
			if (this.modalObj) this.modalObj.hide();
		}
	}
};
</script>
<style>
.position-absolute {
	background: white;
	max-height: 200px;
	overflow-y: auto;
	border: 1px solid #ddd;
}
</style>